module.exports = __webpack_public_path__ + "img/how-to-play.1bb8a173.jpg";